import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialog: css`
    z-index: 3;
  `,
  content: css`
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  `,
  body: css`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  `,
  editorContainer: css`
    flex: 1;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 520px;
    gap: 14px;
  `,
  editorWrapper: css`
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  `,
  previewAsCandidateContainer: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  `,
  floatingWrapper: css`
    position: absolute;
    bottom: 0;
  `,
  message: css`
    padding-bottom: 24px;
  `,
  toolbar: css`
    padding: 0 8px 8px;
  `,
  title: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  `,
  languageSelector: css`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
